<template>
  <v-form lazy-validation @submit.prevent="next">
    <p class="text-xs-center" style="font-size: 16px">
      {{ $t('surveys.create_survey.check_alert') }}
    </p>
    <div v-for="(question, i) in poll.questions" :key="i" id="question-id">
      <v-layout wrap row class="questions-size">
        <v-flex xs6 md8 lg8>
          <v-textarea
            v-model="question.question"
            :prefix="i + 1 + '.'"
            hide-details
            rows="1"
            auto-grow
            disabled
            counter
            maxlength="220"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap row class="questions-size">
        <v-flex xs12 md8 lg8>
          <v-select
            :items="types"
            item-text="name"
            item-value="value"
            v-model="question.type"
            required
            disabled
          />
        </v-flex>
      </v-layout>
      <div v-for="(answer, a) in question.answers" :key="a">
        <v-layout
          wrap
          row
          class="questions-size"
          v-show="
            question.type != 'TEXT' ||
            question.question !=
              '¿Su hijo(a) presenta algunos de los siguientes síntomas?'
          "
        >
          <v-flex xs12 md8 lg8 px-5>
            <p style="margin-top: 16px">{{ answer.answer }}</p>
          </v-flex>
          <v-flex lg2>
            <v-checkbox color="primary" v-model="answer.alert"></v-checkbox>
          </v-flex>
        </v-layout>
      </div>
      <v-divider />
    </div>
  </v-form>
</template>

<script>
import desition from '../../Dialogs/Confirm'

export default {
  components: {
    desition,
  },
  props: ['poll', 'isLocked'],
  data: () => ({
    types: [
      { name: 'SIMPLE', value: 'SINGLE' },
      { name: 'MULTIPLE', value: 'MULTIPLE' },
      { name: 'ABIERTA', value: 'TEXT' },
    ],
    modals: {
      confirmDeleteQuestion: false,
    },
    questionToDeleted: '',
  }),
  methods: {
    removeQuestion(index) {
      this.questionToDeleted = index
      this.modals.confirmDeleteQuestion = true
    },
    addStatus(question) {
      question.answers.push({ alert: '' })
    },
  },
}
</script>

<style>
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.questions-size .v-text-field {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.questions-size .v-input__slot {
  margin-bottom: 0 !important;
}

.questions-size .v-label {
  font-size: 14px !important;
}
.questions-size .v-input {
  font-size: 14px !important;
}

.questions-size .add-question-icon .v-btn {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
